var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvgoOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 40,
    viewBox: "0 0 64 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.49512,
    width: 4,
    height: 38,
    rx: 2,
    fill: "#17B26A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13.4951,
    width: 4,
    height: 26,
    rx: 2,
    fill: "#17B26A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 8.49512,
    width: 4,
    height: 31,
    rx: 2,
    fill: "#17B26A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 15.4951,
    width: 4,
    height: 24,
    rx: 2,
    fill: "#17B26A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 11.4951,
    width: 4,
    height: 28,
    rx: 2,
    fill: "#17B26A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 0.495117,
    width: 4,
    height: 39,
    rx: 2,
    fill: "#17B26A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 5.49512,
    width: 4,
    height: 34,
    rx: 2,
    fill: "#17B26A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgoOrder);
export default __webpack_public_path__ + "static/media/avgo_order.90ef334164f0acfc449192c5b167056b.svg";
export { ForwardRef as ReactComponent };